import request from "@/utils/request";

export default function agentGetDeviceIdNameList(params) {
    return request({
        url: `/device/device/agentGetDeviceIdNameList`,
        params: params
    })
}
